import React, {useEffect, useState} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import {StartupShowcaseBreadCrum} from '../core/_constants'
import StartupDetails from './StartupDetails'
import StartupFullWidthCard from './StartupFullWidthCard'
import {Form, Pagination} from 'react-bootstrap'
import {Link, useParams} from 'react-router-dom'
import {getStartupShowcase} from '../core/_requests'
import {useAuth} from '../../auth'
import {toast} from 'react-toastify'

const StartupDetail: React.FC = () => {
  const {formatMessage} = useIntl()
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [pageNumbers, setPageNumbers] = useState<number[]>([]) //eslint-disable-line
  const [documentPerPage, setDocumentPerPage] = useState<number>(10)
  const [count, setCount] = useState<number>(0) //eslint-disable-line
  const {startupShowcaseId} = useParams()
  const [, setLoading] = useState<boolean>(true)
  const {companyId} = useAuth()
  const [startupShowcaseDetails, setStartupShowcaseDetails] = useState<any>()

  console.log(startupShowcaseId, ' startupShowcaseId')

  const handleDocumentsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setDocumentPerPage(Number(event.target.value))
    setCurrentPage(1)
  }

  const getStartupShowcaseDtails = async () => {
    try {
      setLoading(true)
      const {
        data: {success, data, errors},
      } = await getStartupShowcase(companyId!, startupShowcaseId!)
      if (success) {
        setStartupShowcaseDetails(data)
      } else {
        errors?.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getStartupShowcaseDtails()
  }, []) //eslint-disable-line

  console.log(startupShowcaseDetails, ' startupShowcaseDetails')

  return (
    <>
      <PageTitle
        breadcrumbs={StartupShowcaseBreadCrum}
        description={formatMessage({id: 'Startup Showcase'})}
      >
        {formatMessage({id: 'Startup Showcase'})}
      </PageTitle>
      <div className='px-6'>
        <Link to={'../'} className='bg-transparent text-primary border-0'>
          <i className='fa-solid fa-arrow-left pe-2' style={{color: '#4776e6'}}></i>
          {formatMessage({id: 'Go back'})}
        </Link>
        <div className='my-6'>
          <div className='p-4 bg-white rounded-3' style={{height: 'auto'}}>
            <StartupDetails />
          </div>
          <div className='mt-4'>
            <h1 className='font-size-20 my-4'>Other Technology Startups</h1>
            {Array.from({length: 4}, (_, index) => (
              <StartupFullWidthCard key={index} />
            ))}
            <div className={'w-100 d-flex justify-content-between align-items-center px-0 mt-8'}>
              <div className='d-flex gap-2 w-100 align-items-center'>
                <Form.Select
                  aria-label='Default select example'
                  className='px-4 py-3 w-80px'
                  value={documentPerPage}
                  onChange={handleDocumentsPerPageChange}
                >
                  <option value='10'>{formatMessage({id: '10'})}</option>
                  <option value='20'>{formatMessage({id: '20'})}</option>
                  <option value='50'>{formatMessage({id: '50'})}</option>
                  <option value='100'>{formatMessage({id: '100'})}</option>
                </Form.Select>
                <span className='font-size-13'>
                  {`Showing ${(currentPage - 1) * documentPerPage + 1} to ${Math.min(
                    (currentPage - 1) * documentPerPage + 1 + documentPerPage - 1,
                    count
                  )} of ${count} records`}
                </span>
              </div>
              <Pagination className='w-100 d-flex flex-end'>
                <Pagination.First
                  key='first'
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(1)}
                />
                <Pagination.Prev
                  key='prev'
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                />
                {pageNumbers.map((number) => (
                  <Pagination.Item
                    key={number}
                    active={number === currentPage}
                    onClick={() => setCurrentPage(number)}
                  >
                    {number}
                  </Pagination.Item>
                ))}
                {pageNumbers.length > 6 && (
                  <>
                    {currentPage < pageNumbers.length - 3 && <Pagination.Ellipsis />}
                    {currentPage >= pageNumbers.length - 3 && (
                      <Pagination.Item>{pageNumbers.length}</Pagination.Item>
                    )}
                  </>
                )}
                <Pagination.Next
                  key='next'
                  disabled={currentPage === pageNumbers.length}
                  onClick={() => setCurrentPage((p) => p + 1)}
                />
                <Pagination.Last
                  key='last'
                  disabled={currentPage === pageNumbers.length}
                  onClick={() => setCurrentPage(pageNumbers[pageNumbers.length - 1])}
                />
              </Pagination>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default StartupDetail
